<!-- <div class="backgroundImage">

    <app-header></app-header>

    <div class="container">

        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">


            </div>

           





            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div class="sin-in-page-top">
                    <div class="card-wrapper">
                        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div style="min-height: 500px;">
                         



                          

                                <div *ngIf="show == 2">

                                    <div class="header main-backgroundcolor text-center margin-b">
                                        Address
                                    </div>



                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Address</label>

                                                <input type="text" class="form-control" ngx-google-places-autocomplete
                                                    (onAddressChange)="communityAddress($event)"
                                                    placeholder="Address" />



                                            </div>

                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">

                                            <div class="form-group register-input">
                                                <label for="form_name">Street Address</label>

                                                <input type="text" class="form-control" placeholder="Street Address">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">

                                            <div class="form-group register-input">
                                                <label for="form_name">Suite No</label>

                                                <input type="text" class="form-control" placeholder="Street Address">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">

                                            <div class="form-group register-input">
                                                <label for="form_name">City</label>

                                                <input type="text" class="form-control" placeholder="City">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">State</label>

                                                <input type="text" class="form-control" placeholder="State">
                                            </div>
                                        </div>
                                    </div>



                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Postal Code </label>

                                                <input type="text" class="form-control" placeholder="Postal Code">
                                            </div>
                                        </div>
                                    </div>



                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Country</label>

                                                <input type="text" class="form-control" placeholder="Country">
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input" style="text-align: right;">
                                                <button type="button" class="btn  btn-sm main-backgroundcolor ">Add More
                                                    Address
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                            

                                </div>


                                <div *ngIf="show == 3">


                                    <div class="header main-backgroundcolor text-center margin-b">

                                        Social Links

                                    </div>

                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Website Type</label>
                                                <input type="text" class="form-control" placeholder="Website Type">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row margin-b">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Website</label>
                                                <input type="text" class="form-control" placeholder="Website">
                                            </div>
                                        </div>
                                    </div>



                                    <div class="header main-backgroundcolor text-center margin-b">

                                        About Us
                                    </div>


                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Introduction</label>
                                                <textarea class="form-control" cols="20" rows="5"
                                                    placeholder="Introduction"></textarea>



                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">General Info</label>
                                                <textarea class="form-control" cols="20" rows="5"
                                                    placeholder="General Info"></textarea>


                                            </div>
                                        </div>
                                    </div>
                                </div>


                       

                                <div *ngIf="show == 4">


                                    <div class="header main-backgroundcolor text-center margin-b">

                                        Custom Text Fields

                                    </div>

                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Type</label>
                                                <textarea class="form-control" cols="20" rows="5"
                                                    placeholder="Type"></textarea>



                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Type Description</label>
                                                <textarea class="form-control" cols="20" rows="5"
                                                    placeholder="Description"></textarea>


                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>


                            <div *ngIf="show != 4" class="row">
                                <div class="col-md-12">
                                    <div class="form-group register-input">
                                        <label for="form_name"></label>
                                        <button class="btn main-backgroundcolor btn-lg btn-block"
                                            (click)="nextMove(show)">
                                            Next</button>
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>

          


            </div>
        </div>

    </div>
</div> -->

<router-outlet>
</router-outlet>